import React from "react";
import NavbarHeader from "../Navbar";
import FooterBfsg from "../FooterBfsg";
import main from "../../Image/B2B-Website-UI/Omorovicza-main.jpg";
import Logo from "../../Image/B2B-Website-UI/Omorovicza-logo.png";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Product01 from "../../Image/Top-Products/Omorovicza/Elixir.jpg";
import Product02 from "../../Image/Top-Products/Omorovicza/BlueDiamondSupercream.jpg";
import Product03 from "../../Image/Top-Products/Omorovicza/RejuvenatingNightCream.jpg";
import Product04 from "../../Image/Top-Products/Omorovicza/BlueDiamondSuperSerum.jpg";
import Product05 from "../../Image/Top-Products/Omorovicza/GoldRescueCream.jpg";

const Omorovicza = () => {
  const options = {
    loop: true,
    margin: 50,
    nav: true,
    dots: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="13" viewBox="0 0 42 13" fill="none">' +
        '<path d="M0.357289 6.71437L9.62174 12.273C10.155 12.593 10.8333 12.2089 10.8333 11.587L10.8333 1.41296C10.8333 0.79112 10.155 0.407029 9.62174 0.72696L0.357289 6.28563C0.195455 6.38273 0.195455 6.61727 0.357289 6.71437Z" fill="#7F7F7F"/>' +
        '<path d="M10.8333 6.5L41.1667 6.5" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>",
      '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="13" viewBox="0 0 43 13" fill="none">' +
        '<path d="M41.8093 6.28563L32.5449 0.726957C32.0117 0.407025 31.3333 0.791116 31.3333 1.41295L31.3333 11.587C31.3333 12.2089 32.0117 12.593 32.5449 12.273L41.8093 6.71437C41.9712 6.61727 41.9712 6.38273 41.8093 6.28563Z" fill="#7F7F7F"/>' +
        '<path d="M31.3333 6.5L0.999975 6.5" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  };
  return (
    <div>
      <NavbarHeader />
      <section>
        <div className="container">
          <div className="mt-5"></div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 m-auto">
              <div className="BnadLogo w-100">
                <img className="img-fluid" src={main} />
              </div>
            </div>
            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 m-auto ">
              <div className="row">
                <div className="col-xl-7 col-lg-6 col-md-12 col-sm-12 borderRight">
                  <img className="img-fluid heightWidth" src={Logo} />
                </div>
                <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 m-auto ">
                  <h1 className="titleWithLogo">Mineral-Charged Skincare from Budapest.</h1>
                </div>
              </div>
              <div className="autoHeight" id="ScrollRight">
                <p className="seti">
                  Omorovicza skincare is powered by the Healing Concentrate&trade;,
                  a patented biotechnology of minerals from the ancient healing
                  waters of Budapest. Clinically proven to significantly improve
                  skin hydration, boost elasticity and firmness and strengthen
                  skin barrier.
                </p>

                <p className="seti">
                  Budapest in a bottle.
                </p>
              </div>
            </div>
          </div>

          <div className="TopProducts NewArriavalsList">
            <h3 className="mt-5">TOP PRODUCTS</h3>
            <OwlCarousel className="owl-theme" {...options}>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Elixir</h4>
                    <p>
                      A potent facial oil that deeply nourishes and restores radiance with Hungarian healing waters.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product01} alt="Elixir" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Blue Diamond Super Cream</h4>
                    <p>
                      Ultra-luxurious moisturizer with diamond peptides for visibly firmer, plumper skin.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product02} alt="Blue Diamond Super Cream" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Rejuvenating Night Cream</h4>
                    <p>
                      Rich night cream that repairs and regenerates skin while you sleep with Healing Concentrate&trade;.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product03} alt="Rejuvenating Night Cream" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Blue Diamond Super Serum</h4>
                    <p>
                      Advanced anti-aging serum with diamond peptides and Healing Concentrate&trade; for luminous skin.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product04} alt="Blue Diamond Super Serum" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>Gold Rescue Cream</h4>
                    <p>
                      Intensive rescue cream with colloidal gold to soothe, hydrate and restore stressed skin.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product05} alt="Gold Rescue Cream" />
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>
      <FooterBfsg />
    </div>
  );
};

export default Omorovicza;
